import type { CommandProperties } from '@atlassian/rovo-content-bridge-api';

import { CommandHandler } from './command-handler';

export class StreamCompletedCommandHandler extends CommandHandler<CommandProperties, void> {
	execute(): void {
		// Intentional no-op for stream complete. This handler is used to prevent
		// red herring errors in the console when such commands are received.
	}
}
